import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css'
import styles from "../../styles/tenant.module.css"
import { useForm, useFieldArray } from 'react-hook-form'
import { useMutation, useQuery } from "@apollo/client";
import { CREATE_DATA_INT, GET_DATA_INTEGRATION_BY_ID, GET_TENANT_BY_ID } from "../../graphql/TenantQueries";
import { Typography } from "@mui/material";
import ErrorDisplay from "../common/ErrorDisplay";


function AddDataIntegrationModal({ fieldData, setOpenAddDataIntModal, setOpenActionModal }: any) {
    const { register, handleSubmit, formState: { errors }, control, watch } = useForm()
    const { loading, error, data } = useQuery(GET_TENANT_BY_ID, { variables: { id: fieldData } })
    const [addTenantDataIntegration, { loading: mutationLoading, error: mutationError }] = useMutation(CREATE_DATA_INT, {
        refetchQueries: [
          {query: GET_DATA_INTEGRATION_BY_ID, variables: { id: fieldData }  }, 
          'getDataIntegrationByTenantId' 
        ],
      });
    const { fields, append, remove } = useFieldArray({ control, name: "esri.layers" })
    const watchLayersFieldArray = watch("esri.layers");
    const controlledLayersFields = fields.map((field, index) => {
        return {
            ...field,
            ...watchLayersFieldArray[index]
        };
    });


    const submit = async (formData: any) => {
        try {
            formData.esri.layers.map((el: any) => {
                el.layerNumber = parseInt(el.layerNumber)
                el.group = parseInt(el.group)
            })
            await addTenantDataIntegration({ variables: { input: { ...formData, 
                tenant: { name: `${data.getTenantById.name}`, id: `${data.getTenantById.id}`, displayName: `${data.getTenantById.displayName}` } } } }
                );
            setOpenActionModal(false);
            setOpenAddDataIntModal(false);
        } catch (error) {
            console.error('Error adding data integration:', error);
        }
    }

    if (loading) return <Typography>Loading...</Typography>

    return (
        <div className={styles["formModalContainer"]}>
            <div className={styles["title"]}>
                <h1>Add Data Integration</h1>
            </div>
            <hr></hr>
            <h2>ESRI</h2>
            <div className={styles["body"]}>
                <form onSubmit={handleSubmit(submit)}>
                        <div>
                        <label className={styles["label"]}>Application ID</label>
                        <input {...register('esri.appId')} className={styles["input"]}></input>
                        <label className={styles["label"]}>Application Secret</label>
                        <input {...register('esri.appSecret')} className={styles["input"]}></input>
                        </div>
                        <hr/>
                        <h3 style={{display: 'flex'}}>Layers</h3>
                        {/* <label className={styles["label"]}>Name</label>
                        <input {...register('tags.name')} className={styles["input"]} ></input>
                        <label className={styles["label"]}>Value</label>
                        <input {...register('tags.value')} className={styles["input"]} ></input> */}
                        {controlledLayersFields.map((field, index) => {
                            return (<>
                                <div>
                                    <label className={styles["label"]}>Layer Name</label>
                                    <input {...register(`esri.layers.${index}.layerName`)} className={styles["input"]} />
                                    <label className={styles["label"]}>Display Name</label>
                                    <input {...register(`esri.layers.${index}.displayName`)} className={styles["input"]} />
                                    <label className={styles["label"]}>Layer Number</label>
                                    <input {...register(`esri.layers.${index}.layerNumber`)} className={styles["input"]} type='number'/>
                                    <label className={styles["label"]}>Layer Field Mapping</label>
                                    <input {...register(`esri.layers.${index}.layerFieldMapping`)} className={styles["input"]} />
                                    <label className={styles["label"]}>Tags</label>
                                    <input {...register(`esri.layers.${index}.tags`)} className={styles["input"]} />
                                    <label className={styles["label"]}>Group</label>
                                    <input {...register(`esri.layers.${index}.group`)} className={styles["input"]} type='number' />
                                    </div>
                                    <button type="button" onClick={() => remove(index)} style={{padding: '4px 24px', fontSize: 'small'}}>
                                        Delete
                                    </button>
                                <hr/>
                            </>);
                        })}
                        <button
                            style={{padding: '4px 24px', fontSize: 'small'}}
                            type="button"
                            onClick={() =>
                                append({

                                })
                            }
                        >
                            Add Layer
                        </button>
                    


                    <div style={{ display: 'flex', alignContent: 'center' }}>
                        <button
                            onClick={() => {
                                setOpenAddDataIntModal(false);
                            }}
                            className={styles["button"]}
                        >
                            Cancel
                        </button>
                        <input type='submit' className={styles["button"]} />
                    </div>
                </form>
            </div>
            <ErrorDisplay error={mutationError} />
            <div className={styles["footer"]}>
            </div>
        </div>
    )
}

export default AddDataIntegrationModal;